<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" title="Uvoz garancijskih vplačil" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow v-if="updateSuccess !== true">
			<CCol>
				<CRow>
					<CCol>
						<CSelect
							class="pt-1"
							prepend="Način uvoza:"
							:options="importOptions"
							:value.sync="selectedImportOption"
							custom
						/>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<b-form-file
							v-model="warrantyClaimPaymentsUploadFiles"
							:placeholder="uploadPlaceholder"
							drop-placeholder="Povleci datoteko..."
							browse-text="Brskaj"
							@input="uploadWarrantyClaimPaymentFile"
							accept=".xls, .xlsx"
							multiple/>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
		<CRow v-if="updateSuccess">
			<CCol>
				<b-card>
					<CRow>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število ustvarjenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numCreatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število posodobljenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numUpdatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število povezanih</CCardHeader>
								<CCardBody><span class="display-3">{{ numConnected }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število ne povezanih</CCardHeader>
								<CCardBody><span class="display-3">{{ numNotConnected }}</span></CCardBody>
							</CCard>
						</CCol>
					</CRow>
				</b-card>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="updateSuccess !== true" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="okButtonDisabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
const PH_TEXT = 'Izberi ali povleci datoteko ...';
const MAX_FILE_SIZE = 10485760;
import {
	WARRANTY_CLAIM_PAYMENTS_IMPORT,
} from "@/store/actions/warrantyClaimPayments";

export default {
	name: 'warranty-claim-payments-import-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function () {
			this.selectedImportOption = this.importOptions[0].value;
			this.$refs.modal.show();
		},
		onOkModal: function () {
			if (this.updateSuccess === true) {
				this.$refs.modal.hide();
				this.clearModalData();
			} else {
				this.uploadFile(this, this.warrantyClaimPaymentsUploadFiles);
			}
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Posodobi',
				progress: false,
				disabled: true
			};
			this.showAlert();
			this.numCreatedItems = 0;
			this.numUpdatedItems = 0;
			this.numConnected = 0;
			this.numNotConnected = 0;
			this.totalProcessed = 0;
			this.warrantyClaimPaymentsUploadFiles = null;
			if (this.updateSuccess) this.$emit('emit_warrantyClaimPaymentsImportSuccess');
			this.updateSuccess = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		uploadWarrantyClaimPaymentFile: function () {
			for (const attachment of this.warrantyClaimPaymentsUploadFiles) {
				if (attachment.size > MAX_FILE_SIZE) {
					this.showError(`Datoteka ${attachment.name} je prevelika!`);
					return;
				}
			}
		},
		uploadFile: function (ctx, files) {
			const formData = new FormData();
			files.forEach(file => {
				formData.append('files[]', file);
			});
			formData.append('importType', this.selectedImportOption);
			this.startProgress();
			this.$store.dispatch(WARRANTY_CLAIM_PAYMENTS_IMPORT, formData)
				.then((responseData) => {
					this.stopProgress();
					this.numCreatedItems = responseData.statistics.created;
					this.numUpdatedItems = responseData.statistics.updated;
					this.numConnected = responseData.statistics.connected;
					this.numNotConnected = responseData.statistics.notConnected;
					this.updateSuccess = true;
					this.okButton.label = 'Končaj';
					this.showAlert();
				})
				.catch(error => {
					this.stopProgress();
					this.updateSuccess = false;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						if (error.response.data.usermsg) {
							this.showAlert(error.response.data.usermsg, this.ALERT_TYPE_ERROR);
							return;
						}
						this.showAlert('Napaka pri uvozu datoteke! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Uvozi',
				progress: false,
				disabled: true
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			warrantyClaimPaymentsUploadFiles: null,
			numCreatedItems: 0,
			numUpdatedItems: 0,
			numConnected: 0,
			numNotConnected: 0,
			totalProcessed: 0,
			updateSuccess: null,
			importOptions: [
				{ label: 'Renault/Dacia', value: 'renault' },
				{ label: 'KIA', value: 'kia' },
				{ label: 'Nissan', value: 'nissan' },
				{ label: 'MG', value: 'mg' },
			],
			selectedImportOption: null
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			if (this.updateSuccess > 0) return 'xl';
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		okButtonDisabled () {
			if (this.okButton.disabled && !this.warrantyClaimPaymentsUploadFiles) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.numberCardHeader {
	min-height: 5.5rem;
}
.alert {
	margin-top: 1rem;
	margin-bottom: 0;
}
</style>
<style>
.tdCatalogNumber {
	width: 10rem;
	min-width: 10rem;
	text-align: center;
}
.tdNote {
	width: 5rem;
	min-width: 5rem;
	text-align: center;
}
.tdLocation {
	width: 9rem;
	min-width: 9rem;
	text-align: center;
}
.tdActions {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
	text-align: center;
}
</style>